import { apolloClient } from '~/apollo-client';
import {
  Flex_CreatePaymentHoldMutation,
  Flex_CreatePaymentHoldMutationVariables,
  PaymentHoldResult,
} from '~/typings/graphql';
import { CREATE_PAYMENT_HOLD } from './create-payment-hold.queries';

export type CreatePaymentHoldParams = {
  accountId: number;
  paymentMethodId: number;
  deletePaymentMethodOnFailure: boolean;
};

export type CreatePaymentHoldResponse = {
  result: `${PaymentHoldResult}`;
  message?: string;
};

export const createPaymentHold = async (
  params: CreatePaymentHoldParams,
): Promise<CreatePaymentHoldResponse> => {
  const response = await apolloClient.mutate<
    Flex_CreatePaymentHoldMutation,
    Flex_CreatePaymentHoldMutationVariables
  >({
    mutation: CREATE_PAYMENT_HOLD,
    variables: { input: { ...params, amountCents: 100 } },
    fetchPolicy: 'no-cache',
  });

  const { result, message } = response.data!.createTemporaryPaymentHold;
  return { result, message: message || undefined };
};
